// extracted by mini-css-extract-plugin
module.exports = {"PromoCodeCardDetails":"PromoCodeCardDetails_sL8b3"};